module.exports = __webpack_public_path__ + "media/images/features/4/dress-3-df68b49b59863f0b59d92830024aaca1.jpg";